import * as actions from "./actions";

export default function reQuoteReducer(state = [], action) {
    switch (action.type) {

    case actions.GET_RE_QUOTE_SUCCESS:
    case actions.GET_RE_QUOTE_FAIL:
    {
        return action.payload;
    }
    default:
        return state;

    }
}
